import { Link } from 'react-router-dom';
import './footer.css';

import linkedin from '../../assets/icons/ld.svg';
import telegram from '../../assets/icons/telegram.svg';
import instagram from '../../assets/icons/inst.svg';
import upwork from '../../assets/icons/upwork.svg';
import github from '../../assets/icons/gh.svg';

function Footer() {
    const year = new Date().getFullYear();
    return(
        <div className="footer">
            <div className="footer__container">
                <div className="footer__social social">
                    <Link to={"https://www.linkedin.com/in/vasyl-bezkorovainyi-ukraine/"} target="_blank" className="social__link">
                        <img src={linkedin} alt="Linkedin icon" className="social__icon" />
                    </Link>
                    <Link to={"https://github.com/Wasileuss/"} target="_blank" className="social__link">
                        <img src={github} alt="Github icon" className="social__icon" />
                    </Link>
                    <Link to={"https://t.me/wasyl_lviv/"} target="_blank" className="social__link">
                        <img src={telegram} alt="Telegram icon" className="social__icon" />
                    </Link>
                    <Link to={"https://www.instagram.com/wasyl.lviv/"} target="_blank" className="social__link">
                        <img src={instagram} alt="Instagram icon" className="social__icon" />
                    </Link>
                    <Link to={"https://www.upwork.com/freelancers/~0141d3a4d86d1ac72b"} target="_blank" className="social__link">
                        <img src={upwork} alt="Upwork icon" className="social__icon" />
                    </Link>
                </div>
                <div className="footer__copyright copyright">
                    <p className="copyright__text">Copyright © {year} All rights reserved</p>
                    <p>
                        <Link to={"https://cv-vasyl-bezkorovainyi.netlify.app/"} target="_blank" className="copyright__link">
                            Created by Wasileuss
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Footer;